import React from 'react'
import { LoadingSkeleton } from '@features/insurance-member-redirect/components/LoadingSkeleton'
import { useInsuranceMemberRedirect } from '@features/insurance-member-redirect/hooks/useInsuranceMemberRedirect'

// redirect for US flow
export const InsuranceMemberRedirect: React.FC = () => {
  useInsuranceMemberRedirect()

  return <LoadingSkeleton />
}
